import type { FieldValue, ItemMetaData } from '@mimir/common/dto/fieldValue';
import { FieldType } from '@mimir/common/mdf/fieldDefinition';
import type { MetaDataSchema } from '@mimir/common/mdf/metadataSchema';
import { DEFAULT_MDF_ID } from '@mimir/common/mdf/mdfDefaults';
import keyBy from 'lodash/keyBy';
import Vue from 'vue';
import { mdfState } from '@mimir/web/globals/mdfState';
import { invariant } from '@mimir/common/util/invariant';

export enum ValueWillRemainUnchangedText {
  MULTIPLE_VALUES = 'Multiple values',
  KEEP_UNCHANGED = 'Keep unchanged',
}

/**
 * Used for emitting new default values in FieldFactory / BaseField
 */
export interface UpdateDefaultValue {
  id: string;
  value: FieldValue | null;
}

/**
 * Used for emitting new field values in MetaDataEditor
 */
export interface UpdateFieldValue {
  id: string;
  value: FieldValue;
  fieldType: FieldType;
  previousFieldValue: FieldValue | undefined;
}

/**
 * Remove file type metadata field from payload metadata
 */
export function discardFileTypeFields(metadata: ItemMetaData | undefined) {
  if (!metadata) {
    return;
  }
  const defaultMdf = mdfState.state.defaultMdf;
  invariant(defaultMdf, 'Default MDF schema must be loaded before discarding file-type fields');
  let customMdf: MetaDataSchema | undefined = undefined;
  if (metadata.formId !== DEFAULT_MDF_ID) {
    customMdf = mdfState.state.getMdfById(metadata.formId);
  }

  const fieldsMappedByFieldId = keyBy([...defaultMdf.fields, ...(customMdf ? customMdf.fields : [])], f => f.fieldId);

  for (const key in fieldsMappedByFieldId) {
    const field = fieldsMappedByFieldId[key];
    if (field.type === FieldType.File) {
      Vue.set(metadata.formData, field.id, undefined);
    }
  }
}

/**
 * Sets border color and less opacity background color to v-chip.
 */
export function getCommonChipStyle(color: string) {
  return `border-color:${color} !important; background-color:${color}60 !important`;
}

export function getOptionalCommonChipStyle(color: string | undefined) {
  if (color === undefined) {
    return '';
  }
  return getCommonChipStyle(color);
}
